<template>
  <div class="chart-wrap">
    <div class="big-chart left" :class="{show: chartIndex === 3}" >
      <div class="big-chart-header"></div>
      <div class="big-chart-main">
        <div>
          <shopee-page></shopee-page>
        </div>
        <div class="big-chart-main-footer">
        
        </div>
      </div>
      <div class="people-wrap">
        <img class="person-image" src="./../../../assets/image/simulation/people-img-1.png" alt="">
        <div v-for="(item,index) in talk.talkItems" :key="index">
          <div class="people-talk"  v-if="index === talk.index">
            <p>{{item}}</p>
            <div class="next-btn" v-if="talk.index < talk.talkItems.length -1">
              <i class="el-icon-caret-bottom" @click="talk.index+=1"></i>
            </div>
            <div class="go-btn" v-else>
              <span @click="$emit('finish',4)">明白了</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import shopeePage from './../components/shopee'
  export default {
    name: "chartComponent2",
    props:['chartIndex'],
    components:{
      shopeePage
    },
    data(){
      return {
        talk:{
          index:0,
          talkItems:[
            "选择一款合适的产品，不仅能为卖家的店铺带来可观的销量，还能塑造良好的店铺形象。因此，选品能力是一个店铺的核心竞争力。",
            "做好店铺选品工作，必须有的放矢，要有一定依据，遵循一定的市场原则，形成正确的选品思路，不能凭借主观臆断进行决策。同时，还必须掌握一些选品技巧。",
            "通过对Shopee平台的调研，我整理了一份平台热卖茶产品的数据，已发送至你的邮箱，请查收"
          ]
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .big-chart {
    width: 92vw;
    position: fixed;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease-in;
    &.left {
      left: 4vw;
      bottom: 26px;
      transform: translateX(-110%);
      .person-image {
        left: 0;
        bottom: 0;
      }
      .big-chart-main {
        padding: 30px 30px 30px 460px;
        box-shadow: 23px 0 20px 10px #63759d;
      }
    }
    &.right {
      right: 10px;
      bottom: 10px;
      transform: translateX(110%);
      .person-image {
        right: 0;
        bottom: 0;
      }
      .big-chart-main {
        padding: 30px 136px 30px 30px;
        margin-right: 200px;
        margin-bottom: 26px;
        box-shadow: -23px 0 20px 10px #63759d;
      }
    }
    &.left.show {
      transform: translateX(0);
      transition: all 0.3s ease-in;
    }
    &.right.show {
      transform: translateX(0);
      transition: all 0.3s ease-in;
    }
    .close {
      border: 2px solid #8495b1;
      width: 80px;
      height: 40px;
      border-radius: 8px;
      box-shadow: 0px -6px 8px 1px #8495b1;
      background: #ffffff;
      cursor: pointer;
      position: relative;
      i {
        animation: rightToleft 2s infinite;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 26px;
        color: #5c6d92;
      }
    }
    .btn {
      cursor: pointer;
      border: 2px solid #8495b1;
      width: 80px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 8px;
      box-shadow: 10px 10px 10px #8495b1;
      background: #ffffff;
      margin-left: 10px;
    }
    .person-image {
      position: absolute;
      width: 384px;
      left: 0;
      bottom: 0;
      z-index: 99;
      filter: drop-shadow(16px 18px 10px #155e9e);
    }
    .people-talk {
      position: absolute;
      left: 10px;
      bottom: 300px;
      z-index: 99;
      width: 400px;
      background: #fa5130;
      padding: 16px 16px 28px 16px;
      -webkit-clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 29% 83%, 35% 100%, 15% 83%, 0 83%);
      clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 29% 83%, 35% 100%, 15% 83%, 0 83%);
      color: #FFFFFF;
      font-family: fangsong,serif;
      animation: talkMove 1s ease-in-out both;
      p {
        font-size: 18px;
        text-indent: 38px;
        font-weight: bolder;
        line-height: 20px;
      }
      .next-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        > i {
          font-size: 20px;
          font-weight: bolder;
          padding: 6px;
          cursor: pointer;
        }
      }
      .go-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
        span {
          cursor: pointer;
          background: #FFFFFF;
          padding: 6px;
          color: #ff5722;
          border-radius: 6px;
          font-weight: bolder;
          font-size: 18px;
          box-shadow: 0px 0px 10px #ffffff;
        }
      }
    }
    .big-chart-main {
      flex-grow: 1;
      flex-shrink: 1;
      border-radius: 10px;
      z-index: 98;
      font-size: 16px;
      backdrop-filter: blur(26px);
      background: transparent;
      p {
        width: 700px;
        padding: 10px;
        line-height: 22px;
        border: 2px solid #8495b1;
        box-shadow: 10px 10px 10px #8495b1;
        border-radius: 10px;
        margin-bottom: 10px;
        background: #FFFFFF;
        span {
          font-size: 18px;
          font-weight: bolder;
          color: red;
        }
      }
      .big-chart-main-footer {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  @keyframes rightToleft {
    0% {
      opacity: 1;
      transform: translate(10%,-50%);
    }
  
    99% {
      transform: translate(-100%,-50%);
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes talkMove {
    0% {
      opacity: 0;
    }
    100% {
      bottom: 400px;
      opacity: 1;
    }
  }
</style>
